<app-page-header [title]="'Periode'" subtitle="verrekening"> </app-page-header>
<div class="content">
    <app-settlements-send [endDate]="endDate"></app-settlements-send>
</div>
